<template>
  <div
    v-if="displayed"
    ref="spModal"
    class="sp-modal"
  >
    <div
      v-if="backdrop"
      class="sp-modal-cache"
      @click="close"
    />
    <div class="sp-modal-card">
      <button class="sp-modal-close-btn" @click="close">
        <IconCloseCircle />
      </button>
      <slot/>
    </div>
  </div>
</template>

<script>

import IconCloseCircle from '@/assets/icons/close-circle.svg?component';

export default {
  components: { IconCloseCircle },
  props: ['displayed', 'backdrop'],
  emits: ['close'],
  watch: {
    displayed: {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.spModal) {
            this.$refs.spModal.classList.add('sp-modal-displayed-transition');
          }
        });
      },
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
